module.exports = __webpack_public_path__ + "img/icon3.7ec8b688.svg";